import React from 'react';
import { Cloud, Sun } from 'lucide-react';

export const LoadingSpinner: React.FC = () => {
  return (
    <div className="flex flex-col items-center space-y-4">
      <div className="relative">
        {/* Animated weather icons */}
        <div className="flex items-center space-x-2">
          <Sun className="h-8 w-8 text-yellow-500 animate-pulse" />
          <Cloud className="h-6 w-6 text-blue-400 animate-bounce" />
        </div>
        
        {/* Spinning loader */}
        <div className="absolute -top-2 -left-2 w-12 h-12 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
      </div>
      
      <div className="text-center">
        <h3 className="text-lg font-medium text-gray-700">Analyzing Weather Data</h3>
        <p className="text-sm text-gray-500 mt-1">
          Querying millions of weather records from NOAA...
        </p>
        
        {/* Progress dots */}
        <div className="flex justify-center space-x-1 mt-3">
          <div className="w-2 h-2 bg-blue-400 rounded-full animate-bounce" style={{animationDelay: '0ms'}}></div>
          <div className="w-2 h-2 bg-blue-400 rounded-full animate-bounce" style={{animationDelay: '150ms'}}></div>
          <div className="w-2 h-2 bg-blue-400 rounded-full animate-bounce" style={{animationDelay: '300ms'}}></div>
        </div>
      </div>
    </div>
  );
};
